import PropTypes from 'prop-types';

export default function GenerateRandomSSN(firstThreeDigits) {
  const secondTwoDigits = Math.floor(Math.random() * 100);

  const thirdFourDigits = Math.floor(Math.random() * 10000);

  const uniqueSSN = `${firstThreeDigits}-${addLeadZeros(secondTwoDigits, 2)}-${addLeadZeros(thirdFourDigits, 4)}`;

  return uniqueSSN;
}

GenerateRandomSSN.propTypes = {
  firstThreeDigits: PropTypes.string.isRequired
};

function addLeadZeros(num, size) {
  var leadZeroNumString = num + ""; // to string

  while (leadZeroNumString.length < size) {
    leadZeroNumString = "0" + leadZeroNumString;
  }

  return leadZeroNumString;
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Prefill/GenerateUniqueSSN.js